import { AgendamientoHotelResumido } from "../../services/agendamientosHotelServicios";
import { Badge, Row } from "react-bootstrap";
import { currencyFormat } from "../../utils/numberUtils";
import HotelIcon from "@mui/icons-material/Hotel";
import { DatosTransporte } from "./components/DatosTransporte";
import { InfoRow } from "./components/InfoRow";
import { SectionTitle } from "./components/SectionTitle";
import { ListaFechas } from "./components/ListaFechas";
import { IconContainer } from "./components/IconContainer";
import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PaidIcon from "@mui/icons-material/Paid";

export const AgendamientoResumidoHotel = ({
  agendamiento,
}: {
  agendamiento: AgendamientoHotelResumido;
}) => {
  const contrataTransporteIda = !!agendamiento.reservaTransporteIda;

  const contrataTransporteVuelta = !!agendamiento.reservaTransporteVuelta;

  const contrataTransporteIdaVuelta = !!agendamiento.reservaTransporteIdaVuelta;

  const contrataTransporte =
    contrataTransporteIda ||
    contrataTransporteVuelta ||
    contrataTransporteIdaVuelta;

  const reservaHotel = agendamiento.reservaHotel;
  const fechasHotel = agendamiento.reservaHotel.fechasProgramadas;
  return (
    <div>
      <h5>
        <IconContainer>
          <HotelIcon />
        </IconContainer>
        Agendamiento de Hotel
        {
          !agendamiento.estaActivo && (
            <Badge bg="danger" pill className="m-2">
              Inactivo
            </Badge>
          )
        }
      </h5>
      <section className="mt-3">
        <div>
          <label className="mb-2 fw-bold" style={{ fontWeight: 500 }}>
            <IconContainer>
              <CalendarMonthIcon />
            </IconContainer>
            Fechas programadas:
          </label>
          <ListaFechas fechas={fechasHotel} />
        </div>
      </section>
      {contrataTransporte && (
        <section>
          {contrataTransporteIda && (
            <div className="mb-4">
              <SectionTitle className="mb-3">
                <IconContainer>
                  <DirectionsBusIcon />
                </IconContainer>
                Datos de transporte de ida
              </SectionTitle>
              <DatosTransporte
                reservaTransporte={agendamiento.reservaTransporteIda!}
              />
            </div>
          )}
          {contrataTransporteVuelta && (
            <div className="mb-4">
              <SectionTitle className="mb-3">
                <IconContainer>
                  <DirectionsBusIcon />
                </IconContainer>
                Datos de transporte de vuelta
              </SectionTitle>
              <DatosTransporte
                reservaTransporte={agendamiento.reservaTransporteVuelta!}
              />
            </div>
          )}
          {contrataTransporteIdaVuelta && (
            <div className="mb-4">
              <SectionTitle className="mb-3">
                Datos de transporte de ida y vuelta
              </SectionTitle>
              <DatosTransporte
                reservaTransporte={agendamiento.reservaTransporteIdaVuelta!}
              />
            </div>
          )}
        </section>
      )}

      <section className="mb-4">
        <SectionTitle className="mb-3">
          <IconContainer>
            <PaidIcon />
          </IconContainer>
          Tarifas y planes
        </SectionTitle>
        {reservaHotel.tarifa && (
          <div className="mb-4">
            <InfoRow label="Tarifa" value={reservaHotel.tarifa!} />
            <InfoRow
              label="Valor final tarifa"
              value={currencyFormat(reservaHotel.precioFinalTarifa!)}
            />
          </div>
        )}

        {reservaHotel.nochesIndividuales && (
          <div className="mb-4">
            <InfoRow
              label="Noches individuales"
              value={`${reservaHotel.nochesIndividuales!}`}
            />
            <InfoRow
              label="Tarifa noche individual"
              value={reservaHotel.tarifaNocheIndividual!}
            />
            <InfoRow
              label="Valor final noche individual"
              value={currencyFormat(reservaHotel.precioFinalNocheIndividual!)}
            />
          </div>
        )}

        {contrataTransporteIda && (
          <Row className="mb-4">
            <InfoRow
              label="Número días transporte ida"
              value={`${
                agendamiento.reservaTransporteIda!.fechasProgramadas.length
              }`}
            />
            <InfoRow
              label="Valor servicio transporte ida"
              value={currencyFormat(
                agendamiento.reservaTransporteIda!.precioFinalTarifa
              )}
            />
          </Row>
        )}
        {contrataTransporteVuelta && (
          <Row className="mb-4">
            <InfoRow
              label="Número días transporte vuelta"
              value={`${
                agendamiento.reservaTransporteVuelta!.fechasProgramadas.length
              }`}
            />
            <InfoRow
              label="Valor servicio transporte vuelta"
              value={currencyFormat(
                agendamiento.reservaTransporteVuelta!.precioFinalTarifa
              )}
            />
          </Row>
        )}
        {contrataTransporteIdaVuelta && (
          <Row className="mb-4">
            <InfoRow
              label="Número días transporte ida y vuelta"
              value={`${
                agendamiento.reservaTransporteIdaVuelta!.fechasProgramadas
                  .length
              }`}
            />
            <InfoRow
              label="Valor servicio transporte ida y vuelta"
              value={currencyFormat(
                agendamiento.reservaTransporteIdaVuelta!.precioFinalTarifa
              )}
            />
          </Row>
        )}
      </section>
    </div>
  );
};
